module.exports = __webpack_public_path__ + "img/ajax-loader.7f0d7ae2.gif";